import { createFileRoute } from "@tanstack/react-router";

import { CockpitPage } from "../../../workspaces/fleet/pages/CockpitPage";
import { useSeat } from "../../../workspaces/fleet/seat";

export const Route = createFileRoute("/_console/teleoperators/cockpit/$ticketId")({
  component: Cockpit,
  // The cockpit carries the LiveKit client — by far the heaviest thing in Fleet, and
  // reached by a minority of sessions. `autoCodeSplitting` puts this component (and
  // therefore livekit-client) in its own chunk; this is the message that stands in for it
  // while it arrives, immediately, because a teleoperator opening a takeover is watching.
  pendingComponent: () => (
    <div className="grid h-full place-items-center text-supporting text-muted-foreground">
      Opening cockpit…
    </div>
  ),
  pendingMs: 0,
});

function Cockpit() {
  const { ticketId } = Route.useParams();
  return <CockpitPage ticketId={ticketId} user={useSeat()} />;
}
